/* eslint-disable no-console */

import humps from 'humps';
import PubNub from 'pubnub';
import store from 'Redux/createStore';
import { grantToken } from 'Redux/modules/webChat/actions';

const TIMEOUT_RETRY_GRANT_TOKEN = 30000;

class PubNubHelper {
  constructor() {
    this.isInitial = false;
  }

  autoGrantToken = async pubnubToken => {
    const parseToken = this.pubnub.parseToken(pubnubToken);
    // ttl is in minutes, recall grant token 30 seconds before it expires
    const timeToRetry = parseToken.ttl * 1000 * 60 - TIMEOUT_RETRY_GRANT_TOKEN;
    clearTimeout(this.timeoutInstance);
    this.timeoutInstance = setTimeout(() => {
      this.grantNewToken();
    }, timeToRetry);
  };

  init = options => {
    const { publishKey, subscribeKey, channelId, token } = options;
    this.channelId = channelId;
    this.pubnub = new PubNub({
      publishKey, // PUBNUB_PUBLISH_KEY,
      subscribeKey, // PUBNUB_SUBSCRIBE_KEY,
      uuid: channelId,
      presenceTimeout: 60,
      heartbeatInterval: 10,
      restore: true,
    });
    this.pubnub.setToken(token);
    this.autoGrantToken(token);
    this.isInitial = true;
  };

  subscribe = receiveMessage => {
    this.addListenerMessage(receiveMessage);
    this.pubnub.subscribe({
      channelGroups: [this.channelId],
    });
    const filterExpression = `(recipient like '${this.channelId}') || (recipient=='all') || (pn_ispresence == 1)`;
    this.pubnub.setFilterExpression(filterExpression);
  };

  unSubscribe = () => {
    if (this.pubnub) {
      this.pubnub.unsubscribe({
        channelGroups: [this.channelId],
      });
      this.removeListener();
    }
  };

  clearIntervalAutoGrantToken = () => {
    clearTimeout(this.timeoutInstance);
  };

  sendMessage = async (channelId, data) => {
    this.pubnub.publish(
      {
        channel: channelId,
        message: humps.decamelizeKeys(data),
        // eslint-disable-next-line no-unused-vars
      },
      async status => {
        if (status.error && status.statusCode === 403) {
          await this.grantNewToken();
          // Retry sending the message after getting a new token
          this.pubnub.publish(
            {
              channel: channelId,
              message: humps.decamelizeKeys(data),
            },
            retryStatus => {
              console.log(retryStatus);
            },
          );
        } else {
          console.log(status);
        }
      },
    );
  };

  addListenerMessage(receiveMessage) {
    this.listener = {
      message: receiveMessage,
    };
    this.pubnub.addListener(this.listener);
  }

  removeListener() {
    if (this.pubnub) {
      this.pubnub.removeListener(this.listener);
      this.isInitial = false;
    }
  }

  grantNewToken = async () => {
    try {
      const { data } = await store.dispatch(grantToken());
      const { token } = data;
      this.pubnub.setToken(token);
      console.log('🚀 ~ PubNubHelper ~ grantNewToken= ~ setToken:');
      this.pubnub.reconnect();
      this.autoGrantToken(token);
    } catch (error) {
      // console.log('error grant pubnub token', error);
      // Retry after 30 seconds if failed to get a new token
      setTimeout(() => {
        this.grantNewToken();
      }, TIMEOUT_RETRY_GRANT_TOKEN);
    }
  };
}

export default new PubNubHelper();
